import React from "react";
import { Aside } from "sprint-common-web";

import { EditAncillaryForm, UpdatedAncillaryItem } from "./EditAncillaryForm";

export interface EditAncillarySideFormProps {
    isOpen: boolean;
    ancillaryToEditId: string;
    onClose(): void;
    onSubmit(updatedAncillary: UpdatedAncillaryItem): void;
}

export const EditAncillarySideForm: React.FC<EditAncillarySideFormProps> = (props: EditAncillarySideFormProps) => {
    const closeSideForm = () => {
        props.onClose();
    };

    const handleSubmit = (updatedAncillary: UpdatedAncillaryItem) => {
        props.onSubmit(updatedAncillary);
    };

    return (
        <Aside isOpen={props.isOpen} type="form" headerText="Edit" onDismiss={closeSideForm}>
            <EditAncillaryForm
                onCancel={closeSideForm}
                onSubmit={handleSubmit}
                ancillaryToEditId={props.ancillaryToEditId}
            />
        </Aside>
    );
};
